module.exports = __webpack_public_path__ + "img/gift5.d9e51577.png";